<template>
  <div class="bank-details-form">
    <div class="dialog-add-account__form-title">
      {{ $t('business_account_data.bank') }}
    </div>
    <div class="dialog-add-account__form-block">
      <div class="dialog-add-account__form-row">
        <!-- Название банка -->
        <div class="dialog-add-account__form-col">
          <div class="dialog-add-account__form-item">
            <div
              class="form-input"
              :class="[
                { 'form-input--full': bankData.bank_name },
                {
                  'form-input--error': errors.bank_name || (serverErrors && serverErrors.bank_name),
                },
              ]"
            >
              <input
                :value="bankData.bank_name"
                @input="updateField('bank_name', $event.target.value)"
                type="text"
              />
              <span class="form-input__label">{{ $t('business_account_data.bank_name') }}</span>
              <div v-if="errors.bank_name" class="form-input__error" v-text="errors.bank_name" />
              <div v-if="serverErrors && serverErrors.bank_name" class="form-input__error">
                <p v-for="(err, index) in serverErrors.bank_name" :key="index">
                  {{ err }}
                </p>
              </div>
            </div>
          </div>
        </div>

        <!-- БИК (только для RU) -->
        <div v-if="locale === 'RU'" class="dialog-add-account__form-col">
          <div class="dialog-add-account__form-item">
            <div
              class="form-input"
              :class="[
                { 'form-input--full': bankData.bic },
                { 'form-input--error': errors.bic || (serverErrors && serverErrors.bic) },
              ]"
            >
              <input
                :value="bankData.bic"
                @input="updateField('bic', $event.target.value)"
                type="text"
              />
              <span class="form-input__label">{{ $t('business_account_data.bic') }}</span>
              <div v-if="errors.bic" class="form-input__error" v-text="errors.bic" />
              <div v-if="serverErrors && serverErrors.bic" class="form-input__error">
                <p v-for="(err, index) in serverErrors.bic" :key="index">
                  {{ err }}
                </p>
              </div>
            </div>
          </div>
        </div>

        <!-- Номер счета (только для RU) -->
        <div v-if="locale === 'RU'" class="dialog-add-account__form-col">
          <div class="dialog-add-account__form-item">
            <div
              class="form-input"
              :class="[
                { 'form-input--full': bankData.iban },
                { 'form-input--error': errors.iban || (serverErrors && serverErrors.iban) },
              ]"
            >
              <input
                :value="bankData.iban"
                @input="updateField('iban', $event.target.value)"
                type="text"
              />
              <span class="form-input__label">{{ $t('business_account_data.account') }}</span>
              <div v-if="errors.iban" class="form-input__error" v-text="errors.iban" />
              <div v-if="serverErrors && serverErrors.iban" class="form-input__error">
                <p v-for="(err, index) in serverErrors.iban" :key="index">
                  {{ err }}
                </p>
              </div>
            </div>
          </div>
        </div>

        <!-- Адрес банка -->
        <div class="dialog-add-account__form-col">
          <div class="dialog-add-account__form-item">
            <div
              class="form-input"
              :class="[
                { 'form-input--full': bankData.bank_address },
                {
                  'form-input--error':
                    errors.bank_address || (serverErrors && serverErrors.bank_address),
                },
              ]"
            >
              <input
                :value="bankData.bank_address"
                @input="updateField('bank_address', $event.target.value)"
                type="text"
              />
              <span class="form-input__label">{{ $t('business_account_data.bank_address') }}</span>
              <div
                v-if="errors.bank_address"
                class="form-input__error"
                v-text="errors.bank_address"
              />
              <div v-if="serverErrors && serverErrors.bank_address" class="form-input__error">
                <p v-for="(err, index) in serverErrors.bank_address" :key="index">
                  {{ err }}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'BankDetailsForm',
  props: {
    bankData: {
      type: Object,
      required: true,
      default: () => ({
        bank_name: '',
        bic: '',
        iban: '',
        bank_address: '',
      }),
    },
    errors: {
      type: Object,
      default: () => ({}),
    },
    serverErrors: {
      type: Object,
      default: null,
    },
    locale: {
      type: String,
      default: 'RU',
    },
  },
  methods: {
    updateField(field, value) {
      this.$emit('update:bankData', {
        ...this.bankData,
        [field]: value,
      });
    },
  },
};
</script>

<style scoped lang="scss">
@import '@/assets/styles/helpers/variables';
@import '@/assets/styles/helpers/mixin';
</style>
